import Signal from '../Signal.js';

export const garbageCollect = new Signal();
export const userScreenOrientation = new Signal();
// Viewport/renderer
export const transformModeChanged = new Signal();
export const transformControlsToggled = new Signal();
export const setZoomLevel = new Signal();
export const composerCreated = new Signal();
export const sceneBackgroundChanged = new Signal();
export const sceneEnvironmentChanged = new Signal();
export const sceneFogChanged = new Signal();
export const sceneFogSettingsChanged = new Signal();
export const sceneGraphChanged = new Signal();
export const sceneRendered = new Signal();
export const cameraChanged = new Signal();
export const cameraResetted = new Signal();
export const cameraDistToModel = new Signal();
export const geometryChanged = new Signal();
export const disposePlane = new Signal();
export const setPlaneMaterial = new Signal();
export const mainObjSize = new Signal();
export const objectSelected = new Signal();
export const objectFocused = new Signal();
export const focusedObjectChanged = new Signal();
export const objectAdded = new Signal();
export const objectChanged = new Signal();
export const objectRemoved = new Signal();
export const newObjectLoaded = new Signal();
export const firstChunkComplete = new Signal();
export const helperAdded = new Signal();
export const helperRemoved = new Signal();
export const materialChanged = new Signal();
export const materialRemoved = new Signal();
export const stylizeObject = new Signal();
export const viewerResize = new Signal();
export const viewportSizeChange = new Signal();
export const aspectRatioUpdate = new Signal();
export const showGridChanged = new Signal();
export const showHelpersChanged = new Signal();
export const refreshSidebarObject3D = new Signal();
export const historyChanged = new Signal();
export const refreshSidebarList = new Signal();
export const thumbSizeChange = new Signal();
export const intersectionsDetected = new Signal();
// Comments/tags
export const commentsLoaded = new Signal();
export const tagsLoaded = new Signal();
export const pdfTagLoaded = new Signal();
export const imageTagLoaded = new Signal();
export const userLoaded = new Signal();
export const selectedCommentUpdated = new Signal();
export const tagColorUpdated = new Signal();
export const addTag = new Signal();
export const deleteTag = new Signal();
export const clickedTag = new Signal();
export const clickedTag2d = new Signal();
export const clearDrawing = new Signal();
export const changeDrawingType = new Signal();
export const showTagDistance = new Signal();
export const warnTagDistGroups = new Signal();
// Zoom/axes
export const rotate = new Signal();
export const editorZoomUpdated = new Signal();
export const zoomScroll = new Signal();
export const imageZoomRequested = new Signal();
export const imageZoomChanged = new Signal();
export const editorDisableZoomFunc = new Signal();
export const switchZoomMode = new Signal();
export const clearMeasurements = new Signal();
export const addMeasurementToScene = new Signal();
export const clearMeasurementsScale = new Signal();
export const addMeasurementScaleToScene = new Signal();
export const applyMeasurementScale = new Signal();
// Language/progress
export const languageChanged = new Signal();
export const renderViewport = new Signal();
export const loadProgress = new Signal();
// Model/quality
export const changeRaycasterLayers = new Signal();
export const updateDefaultRes = new Signal();
// Immersive/panorama/media
export const immersiveModeTrigger = new Signal();
export const immersiveAvatarLoaded = new Signal();
export const panoramaChange = new Signal();
export const checkFirstObject = new Signal();
export const imageViewerChange = new Signal();
export const imageViewerHide = new Signal();
export const activeImageChange = new Signal();
export const selectActiveImage = new Signal();
export const viewerFileNavigationRequested = new Signal();
export const itemProcessFinish = new Signal();
export const findCurrentItem = new Signal();
export const downloadLinksUpdated = new Signal();
export const updateCursorHelperSize = new Signal();
export const updateSpriteInfo = new Signal();
export const interactWithTool = new Signal();
export const sidebarHide = new Signal();
export const addSelectionArea = new Signal();
export const clearSelectedArea = new Signal();
export const changeSelectedAreaColor = new Signal();
export const changeSelectedAreaTexture = new Signal();
export const isVideo = new Signal();
export const pdfChangePage = new Signal();
export const changedMediaCanvas = new Signal();
export const rebuildSceneLights = new Signal();
export const initSceneLights = new Signal();
export const sideBarTabChanged = new Signal();
